<template>
  <div id="appRoot">
    <template v-if="!$route.meta.public">
      <v-app id="inspire" class="app" :dark="darkMode">
        <app-drawer class="app--drawer"></app-drawer>
        <app-toolbar class="app--toolbar"></app-toolbar>
        <v-content>
          <!-- Page Header -->
          <page-header v-if="$route.meta.breadcrumb"></page-header>
          <div class="page-wrapper">
            <transition name="fade">
              <router-view></router-view>
            </transition>
          </div>   
           <!-- App Footer -->
          <v-footer height="auto" class="transparent pa-3 app--footer">
            <v-spacer></v-spacer>
            <span class="caption mr-1"> Hecho con </span> <v-icon color="pink" small>favorite</v-icon>
          </v-footer>
        </v-content>
      </v-app>
    </template>
    <template v-else>
      <transition name="fade">
        <keep-alive>
          <router-view :key="$route.fullpath"></router-view>
        </keep-alive>
      </transition>
    </template>
    <v-snackbar
      :timeout="3000"
      bottom
      right
      :color="snackbar.color"
      v-model="snackbar.show"
    >
      {{ snackbar.text }}
      <v-btn dark flat @click.native="snackbar.show = false" icon> 
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>    
  </div>
</template>
<script>
import AppDrawer from '@/components/AppDrawer';
import AppToolbar from '@/components/AppToolbar';
import AppFab from '@/components/AppFab';
import PageHeader from '@/components/PageHeader';
import AppEvents from  './event';
import axios from '@/api/axios/config';
export default {
  components: {
    AppDrawer,
    AppToolbar,
    AppFab,
    PageHeader,
  },
  data: () => ({
    darkMode: false,
    darkModeBtn: 'dark',
    expanded: true,
    rightDrawer: false,
    snackbar: {
      show: false,
      text: '',
      color: '',
    }
  }),
  created () {
    AppEvents.forEach(item => {
      this.$on(item.name, item.callback);
    });
    window.getApp = this;
    this.checkToken();
    window.getApp.$on('DARK_MODE', () => {
      this.darkMode = (!this.darkMode);
    });
  },
  methods: {
    checkToken(){
      axios.get( 'check-token' ).then( response => {
        if( !response.data.status ){
          this.$router.push( '/logout' );
        }
      });
    }
  },

};
</script>

<style>
  .fade-enter-active, .fade-leave-active {
    transition: opacity .3s;
    position: absolute;
    width: 100%;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
</style>

<style lang="stylus" scoped>
  .setting-fab 
    top:50%!important; 
    right:0;
    border-radius:0  
  .page-wrapper
    min-height:calc(100vh - 64px - 50px - 81px );  

</style>
